module.exports = "/assets/43265437765d3a087324430fdf64497d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2K.png
// module id = 986
// module chunks = 0